import PptxGenJS from 'pptxgenjs'
import { slideFrom } from '../util/slideFrom'
import { KojinPptxComponentsProps } from '../types'

const continueTextLayout = {
  width: 2,
  height: 0.3
}

type continueTextProps = KojinPptxComponentsProps & {
  top: number
}
type continueTextReturnValue = {
	slide: PptxGenJS.Slide
  top: number
}
export const continueText = ({
  top,
  ...other
}: continueTextProps): continueTextReturnValue => {
  const { layout, slide } = other
  slide.addText([{
    text: '次ページに続く',
    options: {
      ...layout.textOption,
      fontSize: layout.baseFont.fontSize * 0.8,
      color: '808080'
    }
  }], {
    x: slideFrom(layout, 'right', continueTextLayout.width), y: top,
    w: continueTextLayout.width, h: continueTextLayout.height,
    margin: [10, 10, 5, 5], 
    align: 'right', valign: 'top'
  })
  return {
    slide,
    top: top + continueTextLayout.height
  }
}